export default __webpack_public_path__ + "static/Difi.io_v3-01-98b298e1a62cf587fc16b8deeda0775a.jpg";